import { render, staticRenderFns } from "./shenghe_pass.vue?vue&type=template&id=27376288&scoped=true&"
import script from "./shenghe_pass.vue?vue&type=script&lang=js&"
export * from "./shenghe_pass.vue?vue&type=script&lang=js&"
import style0 from "./shenghe_pass.vue?vue&type=style&index=0&id=27376288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27376288",
  null
  
)

export default component.exports